export const inboxAppUrl = {
	cpURL: process.env.REACT_APP_INBOX_CP_URL
}
